<template>
  <div class="institutions-page">
    <!-- ===================== HERO ===================== -->
    <header class="kl-hero">
      <div class="kl-hero__decor" aria-hidden="true"></div>
      <div class="kl-hero__inner">
        <span class="kl-hero__eyebrow">KeyLearning</span>
        <h1 class="kl-hero__title">
          {{ $t("home.institutionsView.institutions") }}
        </h1>
        <p class="kl-hero__lead">
          {{ $t("home.institutionsView.subtitle") }}
        </p>
      </div>
    </header>

    <!-- ===================== LOGOS ===================== -->
    <section class="kl-section">
      <div class="kl-shell">
        <div class="logos-grid mt-5">
          <div class="logo-item">
            <a
              href="https://www.duoc.cl"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                class="kl-img-contain"
                src="../../assets/new-page/Logo_Duoc.png"
                alt="Logo Duoc"
              />
            </a>
          </div>
          <div class="logo-item">
            <a
              href="https://ipss.cl/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                class="kl-img-contain"
                src="../../assets/new-page/Logo_IPSS.png"
                alt="Logo IPSS"
              />
            </a>
          </div>
          <div class="logo-item">
            <a
              href="https://www.udalba.cl/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                class="kl-img-contain"
                src="../../assets/new-page/Logo_Udalba.png"
                alt="Logo Udalba"
              />
            </a>
          </div>
          <div class="logo-item">
            <a
              href="https://enac.cl/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                class="kl-img-contain"
                src="../../assets/new-page/Logo_ENAC.png"
                alt="Logo ENAC"
              />
            </a>
          </div>
          <div class="logo-item">
            <a
              href="https://www.iacc.cl/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                class="kl-img-contain"
                src="../../assets/new-page/Logo_IACC.png"
                alt="Logo IACC"
              />
            </a>
          </div>
          <div class="logo-item">
            <a
              href="https://www.uniacc.cl/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                class="kl-img-contain"
                src="../../assets/new-page/Logo_UNIACC.png"
                alt="Logo UNIACC"
              />
            </a>
          </div>
          <div class="logo-item">
            <a
              href="https://www.dromerouniversity.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                class="kl-img-contain"
                src="../../assets/new-page/Logo_DRU.svg"
                alt="Logo DRU"
              />
            </a>
          </div>
          <div class="logo-item">
            <a
              href="https://finis.cl/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                class="kl-img-contain"
                src="../../assets/new-page/Logo_Finis_Terrae.png"
                alt="Logo Finis Terrae"
              />
            </a>
          </div>
        </div>
      </div>
    </section>

    <!-- Sección de Testimonios -->
    <!-- <div class="testimonials-section">
      <div class="section-title text-white">
        {{ $t("home.institutionsView.testimonials") }}
      </div>

      <b-carousel
        id="testimonials-carousel"
        :interval="15000"
        indicators
        controls
        img-width="1024"
        img-height="480"
        class="testimonials-carousel"
      >
        <b-carousel-slide
          v-for="(testimonial, index) in testimonials"
          :key="index"
        >
          <template #img>
            <div class="testimonial-card">
              <div class="testimonial-logo">
                <img
                  :src="testimonial.institutionLogo"
                  :alt="testimonial.institution"
                />
              </div>
              <div class="testimonial-content">
                <p class="testimonial-quote">
                  <i class="quote-icon">"</i>
                  {{ testimonial.quote }}
                  <i class="quote-icon">"</i>
                </p>
                <div class="testimonial-author">
                  <div class="testimonial-photo">
                    <img :src="testimonial.photo" :alt="testimonial.name" />
                  </div>
                  <div class="testimonial-info">
                    <p class="testimonial-name m-0">{{ testimonial.name }}</p>
                    <p class="testimonial-position m-0">
                      {{ testimonial.position }}
                    </p>
                    <p class="testimonial-institution m-0">
                      {{ testimonial.institution }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </b-carousel-slide>
      </b-carousel>
    </div> -->

    <ContactForm :id="'contact-us'"></ContactForm>

    <!-- ===================== UBICACIÓN ===================== -->
    <section class="kl-section kl-section--map">
      <div class="kl-shell">
        <div class="text-center">
          <h2 class="kl-title">{{ $t("home.institutionsView.location") }}</h2>
          <span class="kl-title-accent kl-title-accent--center"></span>
        </div>
        <div class="kl-map mt-5">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3330.709467129193!2d-70.5702077!3d-33.40474319999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662ced93c8100f7%3A0x1af432465bddb03d!2sCerro%20El%20Plomo%205931%2C%207561160%20Las%20Condes%2C%20Regi%C3%B3n%20Metropolitana!5e0!3m2!1ses!2scl!4v1714157056208!5m2!1ses!2scl"
            width="100%"
            height="100%"
            frameborder="0"
            style="border: 0"
            allowfullscreen=""
            aria-hidden="false"
            tabindex="0"
            title="Mapa de ubicación KeyLearning"
          ></iframe>
        </div>
      </div>
    </section>

    <ContactBanner></ContactBanner>
  </div>
</template>

<script>
export default {
  name: "InstitutionsView",
  components: {
    ContactForm: () => import("@/components/new-page/ContactForm"),
    ContactBanner: () => import("@/components/new-page/ContactBanner"),
  },
  props: {},
  data() {
    return {
      testimonials: [
        {
          name: "Andrés Henríquez Pérez",
          position: "Director de Innovación Académica",
          institution: "Universidad Finis Terrae",
          institutionLogo: require("../../assets/new-page/Logo_Finis_Terrae.png"),
          photo: require("../../assets/new-page/Andres_Henriquez_Perez.jpeg"),
          quote:
            "KeyLearning ha transformado la manera en que gestionamos nuestros programas académicos. La plataforma es intuitiva y nos ha permitido mejorar significativamente la calidad de nuestros procesos de evaluación y seguimiento de competencias. La plataforma nos ha permitido optimizar nuestros procesos de diseño curricular y seguimiento de perfiles de egreso. El soporte técnico es excelente y siempre están dispuestos a ayudarnos.",
        },
        {
          name: "Ernesto Figueredo",
          position: "Coordinador de Evaluación",
          institution: "Duoc UC",
          institutionLogo: require("../../assets/new-page/Logo_Duoc.png"),
          photo: require("../../assets/new-page/Ernesto_Figueredo.jpg"),
          quote:
            "La implementación de KeyLearning nos ha permitido centralizar toda la información académica en una sola plataforma. El sistema de reportes es excepcional y nos facilita la toma de decisiones basadas en datos concretos. La plataforma es intuitiva y nos ha permitido mejorar significativamente la calidad de nuestros procesos de evaluación y seguimiento de competencias.",
        },
        {
          name: "Jaime Torrealba Cubillos",
          position: "Jefe de Gestión Curricular",
          institution: "Instituto Profesional IPSS",
          institutionLogo: require("../../assets/new-page/Logo_IPSS.png"),
          photo: require("../../assets/new-page/Jaime_Torrealba_Cubillos.jpg"),
          quote:
            "Estamos muy satisfechos con KeyLearning. La plataforma nos ha permitido optimizar nuestros procesos de diseño curricular y seguimiento de perfiles de egreso. El soporte técnico es excelente y siempre están dispuestos a ayudarnos. La facilidad para crear y gestionar evaluaciones, junto con el sistema de competencias, nos ha permitido elevar los estándares de calidad educativa",
        },
      ],
    };
  },
  computed: {},
  methods: {},
  watch: {},
  mounted() {},
  created() {},
};
</script>

<style scoped>
/* ============================================================
   KeyLearning · Sistema de diseño de página pública
   (compartido con AboutUsView)
   ============================================================ */
.institutions-page {
  /* Migrado al sistema global de tokens (utils/styles_kl.css).
     Se conservan los nombres locales para no tocar todas las reglas de abajo;
     ahora sus valores derivan del estándar global. */
  --kl-blue: var(--kl-color-primary);
  --kl-blue-dark: var(--kl-color-primary-deep);
  --kl-teal: var(--kl-color-secondary);
  --kl-ink: var(--kl-text-heading);
  --kl-text: var(--kl-text-body);
  --kl-muted: var(--kl-text-muted);
  --kl-bg: var(--kl-bg-page);
  --kl-card: var(--kl-surface);
  --kl-border: var(--kl-border-soft);
  --kl-shadow: var(--kl-shadow-lg);
  --kl-shadow-hover: var(--kl-shadow-lg-hover);

  background: var(--kl-bg);
  color: var(--kl-text);
  overflow-x: hidden;
}

/* ---------- Primitivas reutilizables ---------- */
.kl-shell {
  max-width: 100%;
  margin: 0 auto;
  padding: 0 var(--kl-space-6);
}
.kl-section {
  padding: 90px 0;
}
.kl-title {
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-fs-title-fluid);
  line-height: var(--kl-lh-tight);
  color: var(--kl-ink);
  margin: 0;
  letter-spacing: var(--kl-ls-tight);
}
.kl-title-accent {
  display: block;
  width: 64px;
  height: 5px;
  margin-top: 18px;
  border-radius: var(--kl-radius-pill);
  background: linear-gradient(90deg, var(--kl-blue) 0%, var(--kl-teal) 100%);
}
.kl-title-accent--center {
  margin-left: auto;
  margin-right: auto;
}

/* ---------- Hero ---------- */
.kl-hero {
  position: relative;
  background: linear-gradient(
    130deg,
    var(--kl-blue-dark) 0%,
    var(--kl-blue) 55%,
    var(--kl-teal) 115%
  );
  color: #ffffff;
  padding: 96px 32px 110px;
  border-bottom-right-radius: 48px;
  overflow: hidden;
}
.kl-hero__decor {
  position: absolute;
  top: -120px;
  right: -80px;
  width: 460px;
  height: 460px;
  border-radius: 50%;
  background: radial-gradient(
    circle at center,
    rgba(255, 255, 255, 0.16) 0%,
    rgba(255, 255, 255, 0) 70%
  );
  pointer-events: none;
}
.kl-hero__inner {
  position: relative;
  z-index: 1;
  max-width: 1180px;
  margin: 0 auto;
}
.kl-hero__eyebrow {
  display: inline-block;
  font-size: var(--kl-fs-small);
  font-weight: var(--kl-fw-bold);
  letter-spacing: var(--kl-ls-wider);
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.85);
  padding: 7px 16px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: var(--kl-radius-pill);
  margin-bottom: 22px;
}
.kl-hero__title {
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-fs-hero);
  line-height: var(--kl-lh-tight);
  margin: 0 0 22px;
  letter-spacing: var(--kl-ls-tight);
}
.kl-hero__lead {
  max-width: 100%;
  font-size: var(--kl-fs-body-lg);
  line-height: var(--kl-lh-relaxed);
  color: rgba(255, 255, 255, 0.92);
  margin: 0;
}

/* ---------- Grid de logos ---------- */
.logos-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 28px;
}
.logo-item {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
  background: var(--kl-card);
  border: 1px solid var(--kl-border);
  border-radius: 18px;
  box-shadow: var(--kl-shadow);
  transition: transform 0.35s ease, box-shadow 0.35s ease,
    border-color 0.35s ease;
  min-height: 160px;
}
.logo-item:hover {
  transform: translateY(-8px);
  border-color: var(--kl-blue);
  box-shadow: var(--kl-shadow-hover);
}
/* .kl-img-contain (global) aporta width/height/object-fit; aquí solo el
   tamaño y el tratamiento visual propios de la grilla de logos. */
.logo-item img {
  height: 110px;
  filter: grayscale(100%);
  opacity: 0.75;
  transition: filter 0.35s ease, opacity 0.35s ease;
}
.logo-item:hover img {
  filter: grayscale(0%);
  opacity: 1;
}

/* ---------- Mapa ---------- */
.kl-section--map {
  background: #ffffff;
}
.kl-map {
  height: 420px;
  border-radius: 22px;
  overflow: hidden;
  box-shadow: var(--kl-shadow);
  border: 1px solid var(--kl-border);
}
.kl-map iframe {
  display: block;
  width: 100%;
  height: 100%;
}

/* ============================================================
   Sección de Testimonios (carousel — actualmente oculto)
   ============================================================ */
.testimonials-section {
  padding: 40px 20px;
  max-width: 1400px;
  margin: 0 auto;
}
.testimonials-carousel {
  margin: 0 auto;
  max-width: 1200px;
}
#testimonials-carousel >>> .carousel-control-prev-icon {
  background-image: url(../../assets/new-page/arrow_carousel_2_left.svg);
  width: 50px !important;
  height: 50px !important;
}
#testimonials-carousel >>> .carousel-control-next-icon {
  background-image: url(../../assets/new-page/arrow_carousel_2_right.svg);
  width: 50px !important;
  height: 50px !important;
}
.testimonial-card {
  background: var(--kl-surface);
  border-radius: var(--kl-card-radius);
  min-height: 550px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}
.testimonial-logo {
  margin-bottom: 30px;
}
.testimonial-logo img {
  max-width: 200px;
  max-height: var(--kl-logo-max-h);
  object-fit: contain;
}
.testimonial-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 950px;
  text-align: center;
}
.testimonial-quote {
  font-size: 1.2rem;
  line-height: var(--kl-lh-tight);
  color: var(--kl-text-body);
  font-style: italic;
  margin-bottom: 40px;
  position: relative;
}
.quote-icon {
  font-size: 1.4rem;
  color: var(--kl-color-secondary);
  font-style: normal;
  font-weight: var(--kl-fw-bold);
}
.testimonial-author {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.testimonial-photo {
  flex-shrink: 0;
}
.testimonial-photo img {
  width: var(--kl-avatar-lg);
  height: var(--kl-avatar-lg);
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid var(--kl-color-primary);
  box-shadow: 0 4px 16px rgba(0, 110, 200, 0.2);
}
.testimonial-info {
  text-align: center;
}
.testimonial-name {
  font-size: 1.25rem;
  font-weight: var(--kl-fw-bold);
  color: var(--kl-color-primary);
}
.testimonial-position {
  font-size: 1rem;
  color: var(--kl-text-muted);
}
.testimonial-institution {
  font-size: 0.95rem;
  color: var(--kl-color-secondary);
  font-weight: var(--kl-fw-semibold);
}
::v-deep .carousel-indicators li {
  background-color: rgba(255, 255, 255, 0.5);
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin: 0 8px;
}
::v-deep .carousel-indicators .active {
  background-color: #ffffff;
}

/* ============================================================
   Responsive
   ============================================================ */
@media (max-width: 992px) {
  .logos-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .kl-section {
    padding: 64px 0;
  }
  .kl-hero {
    padding: 72px 24px 84px;
    border-bottom-right-radius: 32px;
  }
  .kl-shell {
    padding: 0 22px;
  }
  .logos-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  .kl-map {
    height: 340px;
  }
  .testimonial-card {
    padding: 30px 20px;
    min-height: auto;
    margin: 10px;
  }
  .testimonial-quote {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .logos-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .logo-item {
    min-height: 150px;
  }
  .kl-map {
    height: 280px;
  }
}
</style>
